module.exports = __webpack_public_path__ + "img/qr_code.5de245a9.png";